//归集仓管理 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";

/**
获取归集仓列表
 */
export function findWarehouseByDto(data) {
  return request({
    url: `${baseService}/api/warehouse/findWarehouseByDto`,
    method: "post",
    data
  });
}

/**
导出归集仓列表
 */
export function exportWarehouse(data) {
  return request({
    url: `${baseService}/api/warehouse/export`,
    method: "post",
    data
  });
}

/**
查看归集仓详情
 */
export function getWarehouseByNo(warehouseNo) {
  return request({
    url: `${baseService}/api/warehouse/getWarehouseByNo/${warehouseNo}`,
    method: "post"
  });
}

/**
归集仓启停
 */
export function updateWarehouseStatus(warehouseNo, status) {
  return request({
    url: `${baseService}/api/warehouse/updateWarehouseStatus/${warehouseNo}/${status}`,
    method: "PUT"
  });
}

/**
添加归集仓
 */
export function saveWarehouse(data) {
  return request({
    url: `${baseService}/api/warehouse/saveWarehouse`,
    method: "post",
    data
  });
}

/**
编辑归集仓
 */
export function updateWarehouse(data) {
  return request({
    url: `${baseService}/api/warehouse/updateWarehouse`,
    method: "put",
    data
  });
}

/**
归集仓区域分配列表查询
 */
export function findWarehouseAllocate(data) {
  return request({
    url: `${baseService}/api/warehouse/findWarehouseAllocate`,
    method: "post",
    data
  });
}

/**
导出归集仓区域分配列表
 */
export function exportWarehouseAllocate(data) {
  return request({
    url: `${baseService}/api/warehouse/exportWarehouseAllocate`,
    method: "post",
    data
  });
}

/**
分配归集仓区域
 */
export function warehouseAllocate(data) {
  return request({
    url: `${baseService}/api/warehouse/warehouseAllocate`,
    method: "post",
    data
  });
}

/**
获取归集仓下拉列表用于与分配
 */
export function findAllWarehouseOption() {
  return request({
    url: `${baseService}/api/warehouse/findAllWarehouse`,
    method: "post"
  });
}

/**
获取归集仓状态枚举值
 */
export function findWarehouseStatusOption() {
  return request({
    url: `${baseService}/api/warehouse/findWarehouseStatus`,
    method: "post"
  });
}

/**
获取是否 WMS仓库枚举值
 */
export function findWmsWarehouseOption() {
  return request({
    url: `${baseService}/api/warehouse/findWmsWarehouse`,
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/wareHouse.js